(() => {
  const initProduct = (root) => {
    if (!root || root.dataset.productToolsReady === 'true') return;
    root.dataset.productToolsReady = 'true';

    const main = root.querySelector('[data-product-main-image]') || root.querySelector('.product-gallery__main img');
    const thumbsWrap = root.querySelector('[data-product-thumbs]') || root.querySelector('.product-gallery__thumbs');
    const thumbs = Array.from(root.querySelectorAll('[data-product-thumb], .product-gallery__thumbs button[data-photo]'));
    if (!main || !thumbs.length) return;

    let activeIndex = Math.max(0, thumbs.findIndex((thumb) =>
      thumb.getAttribute('aria-current') === 'true' || thumb.getAttribute('aria-pressed') === 'true'
    ));
    let timer = null;
    let paused = false;
    const reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)');

    const keepThumbVisible = (thumb) => {
      if (!thumbsWrap || !thumb) return;
      thumb.scrollIntoView({ behavior: reduceMotion.matches ? 'auto' : 'smooth', block: 'nearest', inline: 'center' });
    };

    const selectImage = (index, userInitiated = false) => {
      activeIndex = (index + thumbs.length) % thumbs.length;
      const thumb = thumbs[activeIndex];
      const nextSrc = thumb.dataset.imageSrc || thumb.dataset.photo;
      const nextAlt = thumb.dataset.imageAlt || thumb.dataset.photoAlt || main.alt || '';
      if (!nextSrc) return;

      main.classList.add('is-changing');
      const preload = new Image();
      preload.onload = () => {
        main.removeAttribute('srcset');
        main.removeAttribute('sizes');
        main.src = nextSrc;
        main.alt = nextAlt;
        main.classList.remove('is-changing');
      };
      preload.onerror = () => main.classList.remove('is-changing');
      preload.src = nextSrc;

      thumbs.forEach((item, i) => {
        const active = i === activeIndex;
        item.classList.toggle('is-active', active);
        item.setAttribute('aria-current', active ? 'true' : 'false');
        item.setAttribute('aria-pressed', active ? 'true' : 'false');
      });

      keepThumbVisible(thumb);
      if (userInitiated) restart();
    };

    const stop = () => {
      if (timer) window.clearInterval(timer);
      timer = null;
    };

    const start = () => {
      stop();
      if (paused || reduceMotion.matches || document.hidden || thumbs.length < 2) return;
      timer = window.setInterval(() => selectImage(activeIndex + 1), 4500);
    };

    const restart = () => start();

    thumbs.forEach((thumb, index) => {
      thumb.addEventListener('click', (event) => {
        event.preventDefault();
        selectImage(index, true);
      });
      thumb.addEventListener('keydown', (event) => {
        if (event.key === 'ArrowRight' || event.key === 'ArrowLeft') {
          event.preventDefault();
          const delta = event.key === 'ArrowRight' ? 1 : -1;
          const next = (index + delta + thumbs.length) % thumbs.length;
          thumbs[next].focus();
          selectImage(next, true);
        }
      });
    });

    root.querySelectorAll('[data-gallery-scroll]').forEach((button) => {
      button.addEventListener('click', () => {
        if (!thumbsWrap) return;
        const direction = Number(button.dataset.galleryScroll || 1);
        thumbsWrap.scrollBy({ left: direction * Math.max(220, thumbsWrap.clientWidth * 0.7), behavior: 'smooth' });
        paused = true;
        stop();
        window.setTimeout(() => { paused = false; start(); }, 2500);
      });
    });

    if (thumbsWrap) {
      thumbsWrap.addEventListener('wheel', (event) => {
        if (Math.abs(event.deltaY) > Math.abs(event.deltaX)) {
          event.preventDefault();
          thumbsWrap.scrollLeft += event.deltaY;
        }
      }, { passive: false });
    }

    root.addEventListener('mouseenter', () => { paused = true; stop(); });
    root.addEventListener('mouseleave', () => { paused = false; start(); });
    root.addEventListener('focusin', stop);
    root.addEventListener('focusout', () => { if (!root.contains(document.activeElement)) start(); });
    root.addEventListener('touchstart', stop, { passive: true });
    root.addEventListener('touchend', () => window.setTimeout(start, 2500), { passive: true });
    document.addEventListener('visibilitychange', start);
    reduceMotion.addEventListener?.('change', start);

    selectImage(activeIndex);
    start();
  };

  const init = () => document.querySelectorAll('[data-product-root], [data-product-tools]').forEach(initProduct);
  document.addEventListener('DOMContentLoaded', init);
  document.addEventListener('shopify:section:load', init);
})();